class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
    this._clickBehaviorEnabled = false;
    this._allowClose = false;

    if (window.innerWidth >= 990) {
      this.enableClickBehavior();
    }

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 990) {
        this.enableClickBehavior();
      }
    });
  }

  forceClose() {
    this._allowClose = true;
    this.mainDetailsToggle.removeAttribute('open');
    setTimeout(() => { this._allowClose = false; }, 50);
  }

  enableClickBehavior() {
    if (this._clickBehaviorEnabled) return;
    this._clickBehaviorEnabled = true;

    const summary = this.mainDetailsToggle.querySelector('summary');
    if (!summary) return;

    summary.style.cursor = 'pointer';

    const topLink = summary.querySelector('a');
    if (topLink) {
      topLink.addEventListener('click', (e) => {
        if (window.innerWidth >= 990) {
          e.preventDefault();
          e.stopPropagation();
          this._allowClose = true;
          if (this.mainDetailsToggle.hasAttribute('open')) {
            this.mainDetailsToggle.removeAttribute('open');
          } else {
            // Fermer tous les autres header-menu
            document.querySelectorAll('header-menu').forEach((menu) => {
              if (menu !== this) menu.forceClose();
            });
            this.mainDetailsToggle.setAttribute('open', '');
          }
          setTimeout(() => { this._allowClose = false; }, 50);
        }
      });
    }

    summary.addEventListener('click', (e) => {
      if (window.innerWidth >= 990) {
        e.preventDefault();
        e.stopPropagation();
        this._allowClose = true;
        if (this.mainDetailsToggle.hasAttribute('open')) {
          this.mainDetailsToggle.removeAttribute('open');
        } else {
          // Fermer tous les autres header-menu
          document.querySelectorAll('header-menu').forEach((menu) => {
            if (menu !== this) menu.forceClose();
          });
          this.mainDetailsToggle.setAttribute('open', '');
        }
        setTimeout(() => { this._allowClose = false; }, 50);
      }
    });

    // Fermer si clic en dehors du méga menu
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target) && this.mainDetailsToggle.hasAttribute('open')) {
        this._allowClose = true;
        this.mainDetailsToggle.removeAttribute('open');
        setTimeout(() => { this._allowClose = false; }, 50);
      }
    });

    // Intercepter la fermeture native et la bloquer si non autorisée
    this.mainDetailsToggle.addEventListener('toggle', (e) => {
      if (!this.mainDetailsToggle.hasAttribute('open') && !this._allowClose) {
        this.mainDetailsToggle.setAttribute('open', '');
      }
    });

    // Désactiver l'ouverture au survol
    this.mainDetailsToggle.addEventListener('mouseenter', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
    });

    this.mainDetailsToggle.addEventListener('mouseover', (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
    });
  }

  close() {
    // Ne rien faire — géré par _allowClose
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
